import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
}

export const AddonToolIcon: React.FC<IconProps> = ({ size = 16, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Wrench handle */}
      <path
        d="M10.5 10.5L13.5 13.5C14 14 14 14.5 13.5 15C13 15.5 12.5 15.5 12 15L9 12"
        stroke="#5B9BD5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Wrench head - outer circle */}
      <circle
        cx="5.5"
        cy="5.5"
        r="4"
        stroke="#5B9BD5"
        strokeWidth="1.5"
        fill="none"
      />
      {/* Wrench opening */}
      <path
        d="M3 3.5L3 7.5C3 7.8 3.2 8 3.5 8L7.5 8C7.8 8 8 7.8 8 7.5L8 3.5C8 3.2 7.8 3 7.5 3L3.5 3C3.2 3 3 3.2 3 3.5Z"
        stroke="#5B9BD5"
        strokeWidth="1.2"
        fill="none"
      />
      {/* Adjustment point */}
      <circle
        cx="5.5"
        cy="5.5"
        r="1"
        fill="#5B9BD5"
      />
    </svg>
  );
};
